import { AssistantPanelModelImpl } from './AssistantPanelModel/impl';
import { AssistantPanelResultDispatcherImpl } from './services/AssistantPanelResultDispatcher/impl';
import { TypedContainerModule } from '@thinkalpha/common/ioc/TypedContainer.js';
import type { ReactBindings } from 'src/types/bindings';

export const AssistantFeatureModule = new TypedContainerModule<ReactBindings>((bind) => {
    bind('AssistantPanelModel').to(AssistantPanelModelImpl).inSingletonScope();
    bind('AssistantPanelResultDispatcher').to(AssistantPanelResultDispatcherImpl);
});
